import axiosInstance from "./axiosInstance";

/** OpenAPI `CategoryRequestCreateDTO` — POST `/categoryRequests`. */
export type CategoryRequestCreateDTO = {
  name: string;
  text?: string;
};

export type CategoryRequestStatus = "OPEN" | "DONE";

export interface CategoryRequestDTO extends CategoryRequestCreateDTO {
  id?: string;
  status?: CategoryRequestStatus;
  version?: number;
  createdAt?: string;
}

export async function createCategoryRequest(
  payload: CategoryRequestCreateDTO,
  token?: string
): Promise<CategoryRequestDTO> {
  const response = await axiosInstance.post<CategoryRequestDTO>("/categoryRequests", payload, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  return response.data;
}

/** Lists category requests by status (admin). */
export async function listCategoryRequests(
  token: string,
  status: CategoryRequestStatus = "OPEN"
): Promise<CategoryRequestDTO[]> {
  const response = await axiosInstance.get<CategoryRequestDTO[]>("/categoryRequests", {
    headers: { Authorization: `Bearer ${token}` },
    params: { status },
  });
  return response.data ?? [];
}

/** Sets a request's status, e.g. mark DONE once the category was created (admin). */
export async function setCategoryRequestStatus(
  token: string,
  id: string,
  version: number,
  status: CategoryRequestStatus
): Promise<CategoryRequestDTO> {
  const response = await axiosInstance.patch<CategoryRequestDTO>(
    "/categoryRequests",
    { id, version, status },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}
